import React from 'react';
import { motion } from 'framer-motion';
interface SectionHeadingProps {
  kicker?: string;
  headline: React.ReactNode;
  description?: string;
  theme?: 'light' | 'dark';
  align?: 'left' | 'center';
  className?: string;
}
export function SectionHeading({
  kicker,
  headline,
  description,
  theme = 'light',
  align = 'left',
  className = ''
}: SectionHeadingProps) {
  const isDark = theme === 'dark';
  const textColor = isDark ? 'text-ivory' : 'text-ink';
  const subColor = isDark ? 'text-ivory/70' : 'text-ink/65';
  const kickerColor = isDark ? 'text-gold' : 'text-burgundy';
  const alignClass = align === 'center' ? 'text-center items-center mx-auto' : 'text-left items-start';
  return <motion.div initial={{
    opacity: 0,
    y: 16
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-80px'
  }} transition={{
    duration: 0.3,
    ease: [0.23, 1, 0.32, 1]
  }} className={`flex flex-col ${alignClass} max-w-2xl ${className}`} data-id="element-184" data-mp="6svh4wrhfpyv">
      {kicker ? <p className={`text-xs font-semibold uppercase tracking-widest2 ${kickerColor} mb-4`} data-id="element-185" data-mp="1tb0k4qo2wfeg">{kicker}</p> : null}
      <h2 className={`font-display text-4xl md:text-5xl lg:text-6xl leading-[1.05] ${textColor}`} data-id="element-186" data-mp="1ocflgvoh63s4">{headline}</h2>
      {description ? <p className={`mt-6 text-base md:text-lg leading-relaxed ${subColor}`} data-id="element-187" data-mp="231ljigbktnyf">{description}</p> : null}
    </motion.div>;
}